import { Ship } from '../../model/ship'
import { World } from '../../model/world'
import { MoveAction, InterceptAction } from './ship-action'

export class ShipAi {
  constructor() {}

  action(world: World, ship: Ship): MoveAction {
    return new InterceptAction()
  }
}

